/**
 * Brand colour input for the web chat widget: accept any CSS colour an operator types
 * ("white", "#fff", "rgb(0, 62, 126)", "navy") and store it as #rrggbb, so every consumer
 * (the widget's contrast logic, the colour swatch, embed snippets) sees one format.
 * A named colour saved as-is used to leave the widget's header text white on white.
 */

const HEX6 = /^#([0-9a-f]{6})$/i;
const HEX3 = /^#([0-9a-f]{3})$/i;
const RGB = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*[\d.]+\s*)?\)$/i;
// Fallback for environments without a canvas (tests); the browser path uses the canvas,
// which knows every CSS colour name.
const COMMON_NAMES = {
  white: '#ffffff', black: '#000000', navy: '#000080', gray: '#808080', grey: '#808080',
  silver: '#c0c0c0', red: '#ff0000', blue: '#0000ff', green: '#008000', yellow: '#ffff00',
  orange: '#ffa500', purple: '#800080', teal: '#008080', gold: '#ffd700',
};

const toHex = (n) => Number(n).toString(16).padStart(2, '0');

function viaCanvas(value) {
  try {
    const ctx = typeof document !== 'undefined' && document.createElement('canvas').getContext('2d');
    if (!ctx) return undefined;
    ctx.fillStyle = '#010203'; ctx.fillStyle = value; const a = ctx.fillStyle;
    ctx.fillStyle = '#030201'; ctx.fillStyle = value; const b = ctx.fillStyle;
    if (a !== b) return null; // not a colour: fillStyle ignored the assignment
    return a;
  } catch (e) {
    return undefined;
  }
}

/** '#rrggbb' for any valid CSS colour, else null. */
export function normalizeCssColor(value) {
  const v = (value || '').trim();
  if (!v) return null;
  const resolved = viaCanvas(v);
  const s = resolved === undefined ? (COMMON_NAMES[v.toLowerCase()] || v) : resolved;
  if (s === null) return null;
  let m = s.match(HEX6);
  if (m) return `#${m[1].toLowerCase()}`;
  m = s.match(HEX3);
  if (m) return `#${m[1].split('').map((c) => c + c).join('').toLowerCase()}`;
  m = s.match(RGB);
  if (m && [m[1], m[2], m[3]].every((x) => Number(x) <= 255)) return `#${toHex(m[1])}${toHex(m[2])}${toHex(m[3])}`;
  return null;
}
